<template>
  <section>
    <dialogModule
      top="10"
      width="90%"
      :title="$t('vipModule.vipRechargeDialogTitle')"
      :dialogVisible="vipRechargeType"
      bgColor="#f5f7fb"
      data-keyboard=“false”
      @close="closeDialog">
      <span slot="close" class="el-icon-close close-icon cursor" @click="closeDialog"></span>
      <div slot="content" class="row" style="background:#FFF;padding:10px;">
        <div style="height: 800px;width: 100%;padding: 10px;">
          <div style="display: flex;justify-content: space-between;">
            <div class="row-box">
              <img src="../../../assets/images/recharge(5).png" style="width: 100%;height: 128px;" alt="" />
              <div class="row-top">
                <div class="row-img">
                  <img style="width: 70px;height: 70px;" src="@/assets/images/Recharge(2).png" alt="" />
                </div>
                <div>
                  <p>{{ $t('vipModule.vipRechargeNewVipLabel') }}</p>
                  <h1>{{ vipStatisticData.vipCount }}</h1>
                </div>
              </div>
            </div>
            <div class="row-box">
              <img src="../../../assets/images/recharge(6).png" style="width: 100%;height: 128px;" alt="" />
              <div class="row-top">
                <div class="row-img">
                  <img style="width: 70px;height: 70px;" src="@/assets/images/Recharge(3).png" alt="" />
                </div>
                <div>
                  <p>{{ $t('vipModule.vipRechargeRechargeTimesLabel') }}</p>
                  <h1>{{ vipStatisticData.rechargeTimes }}</h1>
                </div>
              </div>
            </div>
            <div class="row-box">
              <img src="../../../assets/images/recharge(7).png" style="width: 100%;height: 128px;" alt="" />
              <div class="row-top">
                <div class="row-img">
                  <img style="width: 70px;height: 70px;" src="@/assets/images/Recharge(4).png" alt="" />
                </div>
                <div>
                  <p>{{ $t('vipModule.vipRechargeRechargeAmountLabel') }}</p>
                  <h1>đ{{ vipStatisticData.rechargeAmount }}</h1>
                </div>
              </div>
            </div>
          </div>
          <div style="display: flex;width: 100%;justify-content: space-between;margin-top: 30px;">
            <div class="search-div">
              {{ $t('vipModule.vipRechargeTimeRangeLabel') }}
              <el-date-picker
                style="margin-left: 10px; width: 280px"
                size="small"
                v-model="timer"
                type="datetimerange"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                range-separator="至"
                :start-placeholder="$t('vipModule.vipRechargeStartDateLabel')"
                :end-placeholder="$t('vipModule.vipRechargeEndDateLabel')">
              </el-date-picker>
            </div>
            <div style="width: 300px;">
              {{ $t('vipModule.vipRechargeVipNameLabel') }}
              <el-input
                v-model="name"
                size="small"
                style="width: 150px;margin-left: 10px;"
                :placeholder="$t('vipModule.vipRechargePleaseEnterText')"></el-input>
            </div>
            <div style="width: 300px;">
              {{ $t('vipModule.vipRechargePhoneLabel') }}
              <el-input
                v-model="phone"
                size="small"
                style="width: 150px;margin-left: 10px;"
                :placeholder="$t('vipModule.vipRechargePleaseEnterText')"></el-input>
            </div>
            <div style="width: 300px;">
              {{ $t('vipModule.vipRechargeStatusLabel') }}
              <el-select
                v-model="state"
                style="width:150px;margin-left: 10px;"
                size="small">
                <el-option
                  v-for="item in payType"
                  :key="item.value"
                  :value="item.value"
                  :label="$t(item.labelKey)"></el-option>
              </el-select>
            </div>
            <div>
              <el-button
                style="width: 100px;border-radius: 4px; "
                size="small"
                @click="resetSearch">
                {{ $t('vipModule.vipRechargeResetBtn') }}
              </el-button>
              <el-button
                style="width: 100px;border-radius: 4px; background-color: #077cf2;color: #FFF;"
                size="small"
                @click="searchRecharge">
                {{ $t('vipModule.vipRechargeConfirmBtn') }}
              </el-button>
            </div>
          </div>
          <el-table
            :data="tableData"
            :header-cell-style="{ textAlign: 'center', background: '#fafafa' }"
            :cell-style="{ textAlign: 'center' }"
            style="width: 100%;margin-top: 30px;border: 1px solid #dedede;border-bottom: 0;margin-bottom: 0;"
            height="500px">
            <el-table-column type="expand" width="40px">
              <template slot-scope="props">
                <el-form label-position="left" inline class="demo-table-expand">
                  <el-form-item :label="$t('vipModule.vipRechargeMemberNameLabel')">
                    <span>{{ props.row.nickName }}</span>
                  </el-form-item>
                  <el-form-item :label="$t('vipModule.vipRechargePhoneLabel')">
                    <span>{{ props.row.phone }}</span>
                  </el-form-item>
                  <el-form-item :label="$t('vipModule.vipRechargeOrderNoLabel')">
                    <span>{{ props.row.sn }}</span>
                  </el-form-item>
                  <el-form-item :label="$t('vipModule.vipRechargeAmountLabel')">
                    <span>{{ props.row.amount }}</span>
                  </el-form-item>
                  <el-form-item :label="$t('vipModule.vipRechargeBeforeRechargeLabel')">
                    <span>{{ props.row.lastBalance }}</span>
                  </el-form-item>
                  <el-form-item :label="$t('vipModule.vipRechargeAfterRechargeLabel')">
                    <span>{{ props.row.afterBalance }}</span>
                  </el-form-item>
                  <el-form-item :label="$t('vipModule.vipRechargeUnpaidAmountLabel')">
                    <span>{{ props.row.unpaidAmount }}</span>
                  </el-form-item>
                  <el-form-item :label="$t('vipModule.vipRechargePaidAmountLabel')">
                    <span>{{ props.row.paidAmount }}</span>
                  </el-form-item>
                  <el-form-item :label="$t('vipModule.vipRechargePaymentMethodLabel')">
                    <span>{{ payState(props.row) }}</span>
                  </el-form-item>
                  <el-form-item :label="$t('vipModule.vipRechargeTimeLabel')">
                    <span>{{ props.row.createTime }}</span>
                  </el-form-item>
                  <el-form-item :label="$t('vipModule.vipRechargeStateLabel')">
                    <span>{{ itemState(props.row) }}</span>
                  </el-form-item>
                </el-form>
              </template>
            </el-table-column>
            <el-table-column
              :label="$t('vipModule.vipRechargeMemberNameLabel')"
              prop="nickName"
              width="150px">
            </el-table-column>
            <el-table-column
              :label="$t('vipModule.vipRechargePhoneLabel')"
              prop="phone"
              width="150px">
            </el-table-column>
            <el-table-column
              :label="$t('vipModule.vipRechargeOrderNoLabel')"
              prop="sn"
              width="180px">
            </el-table-column>
            <el-table-column
              :label="$t('vipModule.vipRechargeAmountLabel')"
              prop="amount"
              width="150px">
            </el-table-column>
            <el-table-column
              :label="$t('vipModule.vipRechargeBeforeRechargeLabel')"
              prop="lastBalance"
              width="170px">
            </el-table-column>
            <el-table-column
              :label="$t('vipModule.vipRechargeAfterRechargeLabel')"
              prop="afterBalance"
              width="150px">
            </el-table-column>
            <el-table-column
              :label="$t('vipModule.vipRechargeUnpaidAmountLabel')"
              prop="unpaidAmount"
              width="170px">
            </el-table-column>
            <el-table-column
              :label="$t('vipModule.vipRechargePaidAmountLabel')"
              prop="paidAmount"
              width="170px">
            </el-table-column>
            <el-table-column
              :label="$t('vipModule.vipRechargePaymentMethodLabel')"
              prop="stateList"
              width="130px"
              style="display: flex;justify-content: center;">
              <template slot-scope="scope" style="display: flex;justify-content: center;">
                <p
                  :title="payState(scope.row)"
                  style="width: 100%;text-align: center;text-overflow: ellipsis;overflow: hidden;word-break: break-all;white-space: nowrap;">
                  {{ payState(scope.row) }}
                </p>
              </template>
            </el-table-column>
            <el-table-column
              :label="$t('vipModule.vipRechargeTimeLabel')"
              prop="createTime"
              width="200px">
            </el-table-column>
            <el-table-column
              :label="$t('vipModule.vipRechargeStateLabel')"
              prop="state"
              width="180px">
              <template slot-scope="scope">
                <div class="box-yuan" v-if="scope.row.state == '0'">
                  <div class="yuan" style="background-color:#f78989;"></div>
                  <span style="color: #f78989;">
                    {{ $t('vipModule.vipRechargeUnpaidLabel') }}
                  </span>
                </div>
                <div class="box-yuan" v-if="scope.row.state == '1'">
                  <div class="yuan" style="background-color:#e6a23c;"></div>
                  <span style="color: #e6a23c;">
                    {{ $t('vipModule.vipRechargePartialPaymentLabel') }}
                  </span>
                </div>
                <div class="box-yuan" v-if="scope.row.state == '2'">
                  <div class="yuan" style="background-color:#67c23a;"></div>
                  <span style="color: #67c23a;">
                    {{ $t('vipModule.vipRechargePaidLabel') }}
                  </span>
                </div>
                <div class="box-yuan" v-if="scope.row.state == '3'">
                  <div class="yuan" style="background-color:#909399;"></div>
                  <span style="color: #909399;">
                    {{ $t('vipModule.vipRechargeCancelledLabel') }}
                  </span>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              :label="$t('vipModule.vipRechargeOperationLabel')"
              prop="desc"
              width="280px">
              <template slot-scope="scope">
                <el-button
                  v-if="scope.row.state == '0' || scope.row.state == '1'"
                  size="mini"
                  style="background-color: #67c23a;color: white;"
                  @click="handleEdit(scope.$index, scope.row)">
                  {{ $t('vipModule.vipRechargeContinuePaymentBtn') }}
                </el-button>
                <el-button
                  v-if="scope.row.state == '0' || scope.row.state == '1'"
                  size="mini"
                  type="danger"
                  @click="handleDelete(scope.$index, scope.row)">
                  {{ $t('vipModule.vipRechargeCancelPaymentBtn') }}
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <section class="section-page row align-center space-end" v-show="totalVip > '0'">
            <el-pagination
              layout="total, prev, pager, next"
              :total="totalVip"
              :page-size="10"
              :pager-count="5"
              @current-change="cahngeCurPage"
              :current-page="page - 0">
            </el-pagination>
          </section>
        </div>
      </div>
    </dialogModule>
    <MemberRecharge
      v-if="rechargeDialog"
      @close="closeRecharge"
      payAgain="Y"
      :againData="againData"
      @lookRecharge="lookRecharge"></MemberRecharge>
  </section>
</template>

<script>
import moment from "moment";
import dialogModule from "@/components/dialogModule.vue";
import MemberRecharge from "./MemberRecharge";
import { vipRechargeStatistic, vipAccountRechargeRecode, secondValidState, accountRechargeBill } from '@/libs/http/modules/vip';
export default {
  components: {
    dialogModule,
    MemberRecharge
  },
  data() {
    return {
      tableData: [],
      vipStatisticData: {},
      deptId: '',//店铺id
      timer: [
        moment().startOf('month').format('YYYY-MM-DD'),
        moment().endOf('month').format('YYYY-MM-DD'),
      ],
      searchLoading: false,
      vipList: [],
      totalVip: 0,
      name: '',
      phone: '',
      state: '2',
      page: 1,
      vipRechargeType: false,
      // 重构payType，将中文label替换为键名，模板中通过$t渲染
      payType: [
        {
          labelKey: 'vipModule.vipRechargeUnpaidLabel',
          value: '0'
        },
        {
          labelKey: 'vipModule.vipRechargePartialPaymentLabel',
          value: '1'
        },
        {
          labelKey: 'vipModule.vipRechargePaidLabel',
          value: '2'
        },
        {
          labelKey: 'vipModule.vipRechargeCancelledLabel',
          value: '3'
        },
      ],
      rechargeDialog: false,
      againData: null,
    };
  },
  created() {
    this.vipRechargeType = true;
    this.deptId = this.$cache.local.get('deptId')
    this.vipStatisticList();
    this.AccountRechargeList();
  },
  methods: {
    handleDelete(e, row) {
      let reqData = {
        id: row.id,
      }
      this.$confirm(
        $t('vipModule.vipRechargeConfirmCancelMsg'),
        $t('vipModule.vipRechargePromptTitle')
      ).then(() => {
        accountRechargeBill(reqData).then(data => {
          this.searchRecharge();
        }).catch(err => {
          this.searchLoading = false;
          this.$message({ type: 'error', message: err, duration: 2000, showClose: true })
        })
      }).catch(err => { })
    },
    handleEdit(e, row) {
      secondValidState({
        id: row.id
      }).then(data => {
        if (data === 'true') {
          this.$message({
            type: $t('vipModule.vipRechargeSuccessLabel'),
            message: $t('vipModule.vipRechargeAmountChangedMsg'),
            duration: 2000,
            showClose: true
          });
          this.searchRecharge();
        } else {
          this.rechargeDialog = true;
          this.againData = row;
        }
      }).catch(error => {
        this.$message({
          type: $t('vipModule.vipRechargeErrorLabel'),
          message: error,
          duration: 2000,
          showClose: true
        })
      })
    },
    lookRecharge() {
      this.searchRecharge();
    },
    payAfter(item) {
      if (item.state == '0') {
        return 'stateN'
      }
      if (item.state == '1') {
        return 'stateY'
      }
      if (item.state == '2') {
        return 'stateY'
      }
      if (item.state == '3') {
        return 'stateG'
      }
    },
    resetSearch() {//重置按钮
      this.timer = '';
      this.name = '';
      this.phone = '';
      this.state = '';
    },
    searchRecharge() {//确定按钮
      const searchData = {};
      if (this.timer) {
        searchData['timer'] = this.timer;
      }
      if (this.name) {
        searchData['name'] = this.name;
      }
      if (this.phone) {
        searchData['phone'] = this.phone;
      }
      if (this.state) {
        searchData['state'] = this.state;
      }
      this.AccountRechargeList(searchData)
      this.vipStatisticList()
    },
    payState(item) {
      const stateList = [];
      item.rechargeDetailList.forEach(i => {
        stateList.push(i.payType)
      });
      return stateList.join(',')
    },
    itemState(item) {//判定支付状态渲染页面
      if (item.state == '0') {
        return this.$t('vipModule.vipRechargeUnpaidLabel')
      } else if (item.state == '1') {
        return this.$t('vipModule.vipRechargePartialPaymentLabel')
      } else if (item.state == '2') {
        return this.$t('vipModule.vipRechargePaidLabel')
      }
      else if (item.state == '3') {
        return this.$t('vipModule.vipRechargeCancelledLabel')
      }
    },
    payAgin(item) {//继续支付
      secondValidState({
        id: item.id
      }).then(data => {
        if (data === 'true') {
          this.$message({
            type: $t('vipModule.vipRechargeSuccessLabel'),
            message: $t('vipModule.vipRechargeAmountChangedMsg'),
            duration: 2000,
            showClose: true
          });
          this.searchRecharge();
        } else {
          this.rechargeDialog = true;
          this.againData = item;
        }
      }).catch(error => {
        this.$message({
          type: $t('vipModule.vipRechargeErrorLabel'),
          message: error,
          duration: 2000,
          showClose: true
        })
      })
    },
    closeRecharge(e) {//关闭支付弹窗
      this.rechargeDialog = false;
      if (e === 'refresh') {
        this.searchRecharge();
      }
    },
    cahngeCurPage(val) {
      this.page = val;
      this.searchRecharge();
    },
    vipStatisticList() {
      this.searchLoading = true;
      let reqData = {

      }
      if (this.timer) {
        reqData['startTime'] = this.timer[0];
        reqData['endTime'] = this.timer[1];
      }
      vipRechargeStatistic(reqData).then(data => {
        this.vipStatisticData = data;
      }).catch(err => {
        this.searchLoading = false;
        this.$message({ type: 'error', message: err, duration: 2000, showClose: true })
      })
    },
    AccountRechargeList(searchData) {
      this.searchLoading = true;
      let reqData = {
        deptId: this.deptId,
        page: this.page + '',
        pageSize: '10'
      }
      if (this.state) {
        reqData['state'] = this.state
      }
      if (searchData) {
        if (searchData.timer) {
          reqData['startTime'] = searchData.timer[0];
          reqData['endTime'] = searchData.timer[1];
        }
        if (searchData.name) {
          reqData['name'] = searchData.name;
        }
        if (searchData.phone) {
          reqData['phone'] = searchData.phone;
        }
        if (searchData.state) {
          reqData['state'] = searchData.state;
        }
      }
      vipAccountRechargeRecode(reqData).then(data => {
        this.vipList = data.items || [];
        this.totalVip = Number(data.totalItem) || 0;
        this.tableData = data.items;
      }).catch(err => {
        this.searchLoading = false;
        this.$message({ type: 'error', message: err, duration: 2000, showClose: true })
      })
    },
    closeDialog() {
      this.vipRechargeType = false;
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss" scoped>
.row {
  .row-box {
    width: 32%;
    position: relative;

    .row-top {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      color: #fff;
      border-radius: 8px;
      display: flex;
      padding: 32px 20px;

      .row-img {
        border-radius: 8px;
        margin-right: 18px;
        background: #fff;
      }

      p {
        font-size: 18px;
        margin-bottom: 12px;
      }
    }
  }

  .vip-title {
    background: #FAFAFA;
    margin-top: 20px;
    height: 44px;
    border: 1px solid #DFDFDF;
    border-bottom: none;
  }

  .vip-title>div,
  .vip-item>div {
    height: 44px;
    line-height: 44px;
    overflow: hidden;

    span {
      margin-left: 10px;
    }
  }

  .vip-list {
    border-left: 1px solid #DFDFDF;
    border-right: 1px solid #DFDFDF;

    .vip-item {
      height: 45px;
      border-bottom: 1px solid #DFDFDF;

      .stateN {
        width: 100px;
        height: 30px;
        border: 1px solid #e7839a;
        color: #e7839a;
        line-height: 30px;
        border-radius: 5px;
      }

      .stateY {
        width: 100px;
        height: 30px;
        color: #66b37b;
        border: 1px solid #66b37b;
        line-height: 30px;
        border-radius: 5px;
      }

      .stateG {
        width: 100px;
        height: 30px;
        color: #808080;
        border: 1px solid #808080;
        line-height: 30px;
        border-radius: 5px;
      }

      .payType {
        width: 160px;
        text-overflow: ellipsis;
        overflow: hidden;
        word-break: break-all;
        white-space: nowrap;
      }
    }

    .choose-row {
      background: #EFF7FF;
    }
  }
}

.section-page {
  margin-top: 15px;
  margin-right: -12px;
  position: absolute;
  bottom: 10px;
}

.box-yuan {
  display: flex;
  align-items: center;
  justify-content: center;

  .yuan {
    width: 10px;
    height: 10px;
    background-color: #808080;
    border-radius: 50%;
    margin-right: 10px;
  }
}
</style>

<style>
.demo-table-expand {
  font-size: 0;
  padding-left: 80px;
}

.demo-table-expand label {
  width: 210px;
  color: #99a9bf;
  //background: red;
}

.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 30%;
  color: black;
}

.el-table__body-wrapper::-webkit-scrollbar {
  /*width: 0;宽度为0隐藏*/
  width: 2px;
  height: 0px;
}

.el-table__body-wrapper::-webkit-scrollbar-thumb {
  border-radius: 2px;
  height: 50px;
  background: #eee;
}

.el-table__body-wrapper::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 2px;
  background: rgba(0, 0, 0, 0.4);
}
</style>

